<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
                <h3 class="font-weight-bold">Staffs</h3>
                <div class="text-xs-right"
                     v-if="trekking_agency && trekking_agency.status===1">
                    <v-btn
                            @click="form=true;formData={};$refs.formRef.reset();"
                            color="blue darken-3"
                            dark
                            fab
                            x-small>
                        <v-icon>add</v-icon>
                    </v-btn>
                    <export-button
                            class="ml-2"/>
                </div>
            </v-flex>
            <v-flex xs12>
                <v-card>
                    <v-layout class="py-1 mx-2" row wrap>
                        <v-flex class="pb-0" xs4>
                            <v-text-field
                                    :elevation="0"
                                    class="hidden-sm-and-down "
                                    flat
                                    hide-details
                                    placeholder="Search by typing here..."
                                    prepend-inner-icon="search"
                                    solo
                                    v-model="searchQuery"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-data-table
                                :footer-props="footerProps"
                                :headers="headers"
                                :items="porters"
                                :loading="loading"
                                :options.sync="pagination"
                                :server-items-length="totalNumber"
                                item-key="id"
                        >
                            <template v-slot:item.action="{ item }"
                                      v-if="trekking_agency && trekking_agency.status===1">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                    @click="edit(item)"
                                                    color="primary"
                                                    dark
                                                    dense
                                                    fab
                                                    v-on="on"
                                                    x-small
                                            >
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                    @click="confirmDelete(item)"
                                                    class="ml-2"
                                                    color="red lighten-1"
                                                    dark
                                                    dense
                                                    fab
                                                    v-on="on"
                                                    x-small
                                            >
                                                <v-icon small>delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete</span>
                                    </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog
                persistent
                transition="dialog-bottom-transition"
                v-model="form"
                width="700"
                v-if="trekking_agency && trekking_agency.status===1"
        >
            <v-card>
                <v-card-title
                        class="headline blue darken-3 white--text"
                        default-title
                >{{formData.id ? 'Edit' : 'New'}} Staff
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-container class="pb-0" grid-list-md>
                        <v-layout wrap>
                            <FormErrorDisplayHandler :errors="errors"></FormErrorDisplayHandler>
                            <v-flex xs12>
                                <v-form class="pa-2" lazy-validation ref="formRef" v-model="valid">
                                    <v-text-field
                                            :rules="[rules.required]"
                                            label="Name *"
                                            outlined
                                            type="text"
                                            v-model="formData.name"
                                    ></v-text-field>
                                  <v-text-field
                                      :rules="[rules.required]"
                                      label="Designation *"
                                      outlined
                                      v-model="formData.designation"
                                  ></v-text-field>
                                    <v-text-field
                                            :rules="[rules.required]"
                                            label="Citizenship Number *"
                                            outlined
                                            type="text"
                                            v-model="formData.citizenship_number"
                                    ></v-text-field>
                                    <v-text-field
                                            :rules="[rules.required,rules.mobile_number]"
                                            label="Mobile Number *"
                                            outlined
                                            v-model="formData.mobile_number"
                                    ></v-text-field>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="form = false; formData={};$refs.formRef.reset();"
                            class="white--text"
                            color="red lighten-1"
                    >Cancel
                    </v-btn>
                    <v-btn
                            :loading="loading"
                            @click="saveModel"
                            class="white--text"
                            color="blue darken-3"
                    >Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    import {validationMixin} from "../mixins/validationMixin";
    import {CommonListMixin} from "../mixins/CommonListMixin";
    import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
    import {mapGetters} from 'vuex';
    import ExportButton from "../components/ExportButton";

    export default {
        components: {FormErrorDisplayHandler,ExportButton},

        data() {
            return {
                model: "porters",

                headers: [
                    {
                        text: 'S.N.',
                        value: 's_no',
                        sortable: false
                    },
                    {
                        text: "Name",
                        value: "name"
                    },
                    {
                        text: "Mobile Number",
                        value: "mobile_number"
                    },
                    {
                        text: "Citizenship Number",
                        value: "citizenship_number"
                    },
                    {
                        text: "Added On",
                        value: "created_at"
                    },
                    {
                        text: "Action",
                        value: "action",
                        sortable: false
                    }
                ]
            };
        },
        mixins: [validationMixin, CommonListMixin],
        computed: {
            ...mapGetters("AuthUser", ["user", "trekking_agency"]),
            porters() {
                return this.$store.state.CommonList.all;
            },
        },
        methods: {
            saveModel() {
                if (this.$refs.formRef.validate()) {
                    this.modelData = this.formData;
                    this.save('Porter')
                }
            },
            edit(item) {
                this.formData = JSON.parse(JSON.stringify(item));
                this.form = true;
            },
            async confirmDelete(item) {
                this.destroy(item, "Porter Deleted Successfully");
            },

        },

        mounted() {
            this.$store.commit("CommonList/setModel", this.model);
        }
    };
</script>
